import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { X, MapPin, TreePine } from "lucide-react";
import { imgSrc } from "@/lib/api";

export default function ProjectDialog({ project, open, onClose }) {
  if (!project) return null;
  const gallery = [project.cover_image, ...(project.gallery || [])].filter(Boolean).filter((u, i, a) => a.indexOf(u) === i);
  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent
        className="max-h-[92vh] max-w-3xl overflow-y-auto rounded-lg border-charcoal/10 bg-ivory p-0 sm:rounded-lg"
        data-testid="project-dialog"
      >
        <DialogTitle className="sr-only">{project.title}</DialogTitle>
        <div className="photo-frame aspect-[4/3] w-full">
          <img src={imgSrc(project.cover_image)} alt={project.title} />
        </div>
        <div className="p-6 sm:p-9">
          <div className="flex flex-wrap items-center gap-3 text-xs text-charcoal/55">
            <span className="font-mono uppercase tracking-[0.18em] text-gold">{project.category}</span>
            {project.location && (
              <span className="inline-flex items-center gap-1"><MapPin size={12} /> {project.location}</span>
            )}
            {project.timber && (
              <span className="inline-flex items-center gap-1"><TreePine size={12} /> {project.timber}</span>
            )}
          </div>
          <h3 className="mt-3 font-serif text-3xl text-charcoal sm:text-4xl">{project.title}</h3>
          {project.description && (
            <p className="mt-4 max-w-xl leading-relaxed text-charcoal/70">{project.description}</p>
          )}

          {gallery.length > 0 && (
            <div className="mt-8 grid grid-cols-2 gap-4">
              {gallery.map((u, i) => (
                <div key={`${u}-${i}`} className="photo-frame aspect-[4/5] rounded-md">
                  <img src={imgSrc(u)} alt={`${project.title} — view ${i + 1}`} loading="lazy" />
                </div>
              ))}
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
